import { decode } from 'friendly-pow/base64';
import { getPuzzleTTL } from 'friendly-pow/puzzle';

export const puzzleExpiry = (solution: string): number => {
  const parts = solution.split('.');
  const puzzle = parts[1];
  // Expiry in milliseconds
  return getPuzzleTTL(decode(puzzle)) * 1000;
};
